import { useToken } from "@dexteel/mesf-core";
import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const AttachmentsDownloadButtons = ({ data }: Props) => {
	const { token: bearerToken } = useToken();

	return (
		<Grid2 container spacing={1} style={{ alignItems: "center" }}>
			{data?.Path && (
				<Grid2 size={{ md: 12, xs: 12 }}>
					<Button
						href={`/backend/files/${data?.UploadFileId}/download?Authorization=${bearerToken}`}
						target="_blank"
						rel="noopener noreferrer"
						fullWidth
						variant="outlined"
						style={{
							textDecoration: "none !important",
							fontWeight: 500,
							fontSize: "12px",
							borderRadius: "3px",
							border: "1px solid #3F51B5",
							color: "#3F51B5",
							background: "#FFFF",
						}}
						download={`${data?.FileName} `}
					>
						DOWNLOAD
					</Button>
				</Grid2>
			)}
		</Grid2>
	);
};
